module.exports = __webpack_public_path__ + "static/media/samuelkaluvuri.3031c31f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/samuelkaluvuri.webp
// module id = 811
// module chunks = 0